import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaymentsDataServiceProvider } from '@services/payments/payments-data-service/payments.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'write-off-modal',
	template: require('./write-off-modal.html')
})
export class WriteOffModalComponent {
	disableButton: boolean;

	@Input() paymentId;
	@Output() updateParent: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(
		private paymentsDataService: PaymentsDataServiceProvider,
		private messageService: MessageService
	) {}

	writeOff() {
		this.disableButton = true;
		this.paymentsDataService
			.writeOff(this.paymentId)
			.finally(() => {
				this.disableButton = false;
				$('#writeOffModal').modal('hide');
			})
			.subscribe(
				() => {
					this.updateParent.emit(true);
					this.messageService.showToaster('s_6', 'payments');
				},
				result => this.errorWriteOff(result.error)
			);
	}

	private errorWriteOff(error): void {
		if (
			error.errorMessage ===
			'Write off feature disabled for copied to QuickBooks invoices'
		) {
			this.messageService.showToaster('e_16', 'qb');
		} else {
			this.messageService.showDefaultErrorMessage(error);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/payments/modals/write-off-modal/write-off-modal.ts